import React from "react";
import { useHistory } from "react-router-dom";
import {
  Paper,
  Box,
  Typography,
  makeStyles,
  Grid,
  IconButton,
} from "@material-ui/core";
import KenInput from "../../../components/KenInputField";
import KenSelect from "../../../components/KenSelect";
import { Link, withRouter } from "react-router-dom";
import KenButton from "../../../components/KenButton";
import { otpGenerator } from "../../../utils/Otp";
import clsx from "clsx";
import KenCheckbox from "../../../components/KenCheckbox";
import { withFormik } from "formik";
import { createContact } from "../../../utils/ApiService";
import * as Yup from "yup";
import configContext from '../../../utils/config';
import validation from "../../../utils/ValidationMessages";
import DialogBox from "./DialogBox";
import CloseIcon from "../../../assets/icons/Cross.png";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "relative",
  },
  hide: {
    display: "none",
  },
  reSend: {
    cursor: "pointer",
    float: "right",
  },
  Heading: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.KenColors.neutral100,
    textAlign: "left",
    textTransform: "uppercase",
    marginBottom: 24,
  },
  change: {
    cursor: "pointer",
    color: "#f69e22",
    fontSize: "15px",
  },
  registerLabel: {
    fontSize: "16px",
    paddingBottom: "20px",
  },
  closeButtonContainer: {
    position: "absolute",
    top: "-16px",
    right: "-16px",
  },
}));

export default withRouter(function SignInInfo(props) {
  //console.log('[SignInInfo] props', props);

  return (
    <div>
      <FormikHoc {...props} />
    </div>
  );
});

const SignInForm = (props) => {
  let history = useHistory();
  const {config} = React.useContext(configContext);

  //console.log("props in siginForm", props);
  const {
    values,
    toggle,
    options,
    handleSnackbarOpen,
    setFieldTouched,
    touched,
    errors,
    handleChange,
    currentRow,
    setFieldValue,
    handleClose,
  } = props;

  const classes = useStyles();
  const [otp, setOtp] = React.useState();
  const [showOtpEnter, setShowOtpEnter] = React.useState(false);
  const [applyingForSelf, setApplyingForSelf] = React.useState(
    values.applyingForSelf
  );

  const [openDialog, setOpenDialog] = React.useState(false);

  const handleApplyForSelf = (e) => {
    setApplyingForSelf(e.target.checked);
    setFieldValue("applyingForSelf", e.target.checked);
    setFieldValue("Relation", "");
    touched.Relation = false;
  };
  //console.log("current row in signin", currentRow);

  const change = (name, e, index) => {
    e.persist();
    handleChange(e);
    setFieldTouched(name, true, false);
  };

  React.useEffect(() => {
    if (otp) {
      alert(`Please note down the OTP for further process. The OTP is ${otp}`);
    }
  }, [otp]);

  const handleOtp = () => {
    if (values.phone.length === 10) {
      if (config.smsURL) {
        setShowOtpEnter(true);
        let access_token = localStorage.getItem("access_token");
        fetch(
          `${config.smsURL}/otp?email=${values.email}`,
          // `${applicationConfig.smsURL}/otp?email=${values.email}&mobileno=${values.phone}`,
          // fetch(`http://localhost:5000/api/app/otp?mobileno=${values.phone}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${access_token}`,
            },
          }
        )
          .then((response) => response.text())
          .then((result) => {
            console.log(result);
          })
          .catch((error) => console.log("error", error));
      } else {
        setShowOtpEnter(true);
        setOtp(otpGenerator());
      }
    } else {
      handleSnackbarOpen("error", "Invalid Mobile/Phone Number");
      // if(!values.firstName || !values.lastName)
    }
  };

  const handleSubmitotp = () => {
    if (config.smsURL) {
      let access_token = localStorage.getItem("access_token");
      fetch(
        `${config.smsURL}/validateotp?email=${values.email}&otp=${values.userOTP}`,
        // `${applicationConfig.smsURL}/validateotp?email=${values.email}&mobileno=${values.phone}&otp=${values.userOTP}`,
        // fetch(`http://localhost:5000/api/app/validateotp?mobileno=${values.phone}&otp=${values.userOTP}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
        .then((response) => response.text())
        .then((result) => {
          let data = JSON.parse(result);
          if (data.status) {
            let self;
            if (values.applyingForSelf) {
              self = "Yes";
            } else self = "No";

            const signInPayload = {
              Email: values.email,
              Phone: values.phone,
              InstituteId: currentRow.instituteId,
              First_Name: values.firstName,
              Last_Name: values.lastName,
              Gender: values.gender,
              AcademicYear: currentRow.AcademicYear,
              Self: self,
            };
            createContact(signInPayload)
              .then((resp) => {
                if (resp.contactType === "New" && resp.ContactId === "null") {
                  handleSnackbarOpen(
                    "error",
                    "Something went wrong, Please try again later."
                  );
                } else {
                  if (
                    resp.contactType !== "Existing" &&
                    resp.ContactId !== "null"
                  ) {
                    localStorage.setItem("userEmail", values.email);
                    localStorage.setItem("contactID", resp.ContactId);
                    // localStorage.setItem('applyingForSelf', values.applyingForSelf);
                    localStorage.setItem("userPhone", values.phone);
                    localStorage.setItem("firstName", values.firstName);
                    localStorage.setItem("lastName", values.lastName);
                    history.push({
                      pathname: `/intro/${currentRow.programId}`,
                      state: {
                        academicProgramDetails: currentRow,
                        userDetails: {
                          phoneNumber: values.phone,
                          email: values.email,
                          relationWithApplicant:
                            values.Relation || localStorage.getItem("relation"),
                          contactID: resp.ContactId,
                          applyingForSelf: values.applyingForSelf,
                          contactType: resp.contactType,
                          ApplicantAccount: resp.ApplicantAccount,
                          RelationsAccount: resp.RelationsAccount,
                          First_Name: values.firstName,
                          Last_Name: values.lastName,
                        },
                        applicationDetails: {
                          draft: false,
                        },
                        ParentId: resp.ContactId,
                        Email: values.email,
                      },
                      search: `?name=${currentRow.academicProgram}&instId=${currentRow.instituteId}`,
                    });

                    setOpenDialog(true);
                  } else {
                    handleSnackbarOpen(
                      "error",
                      "Already Registered with same Email or Mobile"
                    );
                  }
                }
              })
              .catch((error) => {
                //setLoading(false);
                console.log("Error [SignInInfo] Create Contact:", error);
              });
          } else {
            handleSnackbarOpen("error", "Invalid OTP. Please try again.");
            setShowOtpEnter(true);
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      if (otp === props.values.userOTP) {
        let self;
        if (values.applyingForSelf) {
          self = "Yes";
        } else self = "No";
        const signInPayload = {
          Email: values.email,
          Phone: values.phone,
          InstituteId: currentRow.instituteId,
          First_Name: values.firstName,
          Last_Name: values.lastName,
          Gender: values.gender,
          AcademicYear: currentRow.AcademicYear,
          Self: self,
        };
        createContact(signInPayload)
          .then((resp) => {
            if (resp.contactType !== "Existing" && resp.ContactId !== "null") {
              setOpenDialog(true);
              // localStorage.setItem('userEmail', values.email);
              localStorage.setItem("contactID", resp.ContactId);
              // localStorage.setItem('applyingForSelf', values.applyingForSelf);
              localStorage.setItem("userPhone", values.phone);
              localStorage.setItem("firstName", values.firstName);
              localStorage.setItem("lastName", values.lastName);
              history.push({
                pathname: `/intro/${currentRow.programId}`,
                state: {
                  academicProgramDetails: currentRow,
                  userDetails: {
                    phoneNumber: values.phone,
                    email: values.email,
                    relationWithApplicant:
                      values.Relation || localStorage.getItem("Relation"),
                    contactID: resp.ContactId,
                    applyingForSelf: values.applyingForSelf,
                    contactType: resp.contactType,
                    ApplicantAccount: resp.ApplicantAccount,
                    RelationsAccount: resp.RelationsAccount,
                    First_Name: values.firstName,
                    Last_Name: values.lastName,
                  },
                  applicationDetails: {
                    draft: false,
                  },
                  ParentId: resp.ContactId,
                  Email: values.email,
                },
                search: `?name=${currentRow.academicProgram}&instId=${currentRow.instituteId}`,
              });
            } else {
              handleSnackbarOpen(
                "error",
                "Already Registered with same Email or Mobile"
              );
            }
          })
          .catch((error) => {
            //setLoading(false);
            console.log("Error [SignInInfo] Create Contact:", error);
          });
      } else {
        handleSnackbarOpen("error", "Invalid OTP. Please try again.");
        setShowOtpEnter(true);
      }
    }
  };

  const relations = [
    {
      label: "Father",
      value: "Father",
    },
    {
      label: "Mother",
      value: "Mother",
    },
    {
      label: "Guardian",
      value: "Guardian",
    },
  ];

  return (
    <form>
      {currentRow && (
        <DialogBox
          title={"CONFIRMATION"}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          message="Do you want to continue?"
          okText="Yes"
          notOkText="No"
          handleDialogSubmit={handleSubmitotp}
          width={"sm"}
        >
          <Typography style={{ marginBottom: 8 }}>
            You are applying for Academic program{" "}
            <span style={{ color: "#000000", fontWeight: 600 }}>
              {currentRow.academicProgram}
            </span>
          </Typography>
        </DialogBox>
      )}
      <Paper className={classes.paper} elevation={0}>
        <Box pt={1} className={classes.closeButtonContainer}>
          <IconButton aria-label="delete" color="primary" onClick={handleClose}>
            <img src={CloseIcon}></img>
          </IconButton>
        </Box>
        <Box textAlign="center">
          <Box pt={1}>
            <Typography variant="body2" className={classes.registerLabel}>
              REGISTER
            </Typography>
          </Box>

          <Box pt={1}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3} md={6}>
                <KenInput
                  required
                  label="First Name"
                  name="firstName"
                  value={values.firstName}
                  onChange={change.bind(null, "firstName")}
                  errors={errors.firstName}
                  touched={touched.firstName}
                />
              </Grid>
              <Grid item xs={12} sm={9} md={6}>
                <KenInput
                  required
                  label="Last Name"
                  name="lastName"
                  value={values.lastName}
                  onChange={change.bind(null, "lastName")}
                  errors={errors.lastName}
                  touched={touched.lastName}
                />
              </Grid>
            </Grid>
          </Box>
          <Box pt={1}>
            <KenInput
              required
              label="Email Address"
              name="email"
              value={values.email}
              onChange={change.bind(null, "email")}
              errors={errors.email}
              touched={touched.email}
            />
          </Box>
          <Box pt={1}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <KenInput
                  required
                  label="Phone Number"
                  name="phone"
                  value={values.phone}
                  onChange={change.bind(null, "phone")}
                  startAdornment
                  errors={errors.phone}
                  touched={touched.phone}
                  startAdornmentIcon={
                    <div style={{ marginTop: "-2px", marginBottom: "-4px" }}>
                      <KenSelect
                        options={options}
                        defaultValue={() => {
                          return "+91";
                        }}
                      />
                    </div>
                  }
                />
              </Grid>
            </Grid>
          </Box>

          <div>
            {values.applyingForSelf === false && (
              <div>
                <Box pt={1}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12}>
                      <KenSelect
                        label="Relation"
                        name="Relation"
                        onChange={change.bind(null, "Relation")}
                        required={true}
                        options={relations}
                        value={values.Relation}
                        errors={errors.Relation}
                        touched={touched.Relation}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </div>
            )}
            <Box
              className={clsx({ [classes.hide]: showOtpEnter })}
              pt={1}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <div className="applyselfLabel">
                <KenCheckbox
                  label="Applying for self"
                  style={{ fontSize: "14px" }}
                  name="applyingForSelf"
                  value={applyingForSelf}
                  onChange={(e) => {
                    handleApplyForSelf(e);
                  }}
                />
              </div>
              <KenButton
                variant="secondary"
                onClick={() => {
                  handleOtp();
                }}
              >
                Get OTP
              </KenButton>
            </Box>

            <div className={clsx({ [classes.hide]: !showOtpEnter })}>
              <Box pt={1}>
                <Typography
                  color="primary"
                  className={classes.reSend}
                  onClick={() => {
                    handleOtp();
                  }}
                >
                  Resend-OTP
                </Typography>
                <KenInput
                  label="Enter OTP"
                  name="userOTP"
                  errors={errors.userOTP}
                  touched={touched.userOTP}
                  onChange={change.bind(null, "userOTP")}
                  value={values.userOTP}
                  // onChange={(e) => { setOtpUser(e.target.value) }}
                />
                <div className="applyselfLabel">
                  <KenCheckbox
                    label="Applying for self"
                    style={{ fontSize: "14px" }}
                    name="applyingForSelf"
                    value={values.applyingForSelf}
                    onChange={change.bind(null, "applyingForSelf")}
                  />
                </div>
              </Box>

              <Box pt={1} display="flex" justifyContent="flex-end">
                <KenButton
                  variant="primary"
                  //onClick={handleModalClose}
                  onClick={() => {
                    if (
                      !values.firstName ||
                      !values.lastName ||
                      !values.email
                    ) {
                      handleSnackbarOpen(
                        "error",
                        "Please provide all required details"
                      );
                    } else {
                      // setOpenDialog(true);
                      handleSubmitotp();
                    }
                  }}
                >
                  GO
                </KenButton>
              </Box>
              <div></div>
            </div>
          </div>
        </Box>
        <Box pt={1} display="flex" justifyContent="center">
          <Typography
            className={classes.change}
            onClick={toggle}
            variant="body2"
          >
            Already Registered? Sign In
          </Typography>
        </Box>
      </Paper>
    </form>
  );
};

// const validationSchema = Yup.object().shape({
//     firstName: Yup.string()
//         .min(2, 'Too Short!')
//         .max(50, 'Too Long!')
//         .required('Required'),
//     email: Yup.string()
//         .email('Invalid email')
//         .required('Required'),
// });

const FormikHoc = (props) => {
  let history = useHistory();
  const {config} = React.useContext(configContext);

  //console.log('props of signIN modal',props);
  const { handleSnackbarOpen, currentRow } = props;
  const numberRegExp = /^[0-9]*$/;

  const SignInFormik = withFormik({
    mapPropsToValues: () => ({
      email: "",
      phone: "",
      firstName: "",
      lastName: "",
      Relation: "",
      userOTP: "",
      applyingForSelf: config.isApplyingForSelf,
    }),

    validationSchema: Yup.object({
      firstName: Yup.string()
        .max(15, `${validation.firstName}`)
        .required("Required"),
      lastName: Yup.string()
        .max(20, `${validation.lastName}`)
        .required("Required"),
      phone: Yup.string()
        .required()
        .matches(numberRegExp, `${validation.phone.invalid}`)
        .test("len", `${validation.phone.digits}`, (val) => {
          if (val) {
            console.log("val", val);
            return val.toString().length === 10;
          }
        }),
      email: Yup.string().email(`${validation.email}`),
      userOTP: Yup.string().required(),
    }),

    handleSubmit: (values) => {
      let self;
      if (values.applyingForSelf) {
        self = "Yes";
      } else self = "No";
      //setLoading(true);
      const signInPayload = {
        Email: values.email,
        Phone: values.phone,
        InstituteId: currentRow.instituteId,
        First_Name: values.firstName,
        Last_Name: values.lastName,
        Gender: values.gender,
        AcademicYear: currentRow.AcademicYear,
        Self: self,
      };

      if (!values.applyingForSelf) {
        localStorage.setItem("Relation", values.Relation);
      }

      //console.log('signInPayload', signInPayload);

      if (values.phone.length === 10) {
        createContact(signInPayload)
          .then((resp) => {
            // console.log('[SignInInfo] Create Contact:', resp);
            //setFormData({...signInPayload });
            if (resp.contactType !== "Existing" && resp.ContactId !== "null") {
              // localStorage.setItem('userEmail', values.email);
              localStorage.setItem("contactID", resp.ContactId);
              // localStorage.setItem('applyingForSelf', values.applyingForSelf);
              localStorage.setItem("userPhone", values.phone);
              localStorage.setItem("firstName", values.firstName);
              localStorage.setItem("lastName", values.lastName);
              history.push({
                pathname: `/intro/${currentRow.programId}`,
                state: {
                  academicProgramDetails: currentRow,
                  userDetails: {
                    phoneNumber: values.phone,
                    email: values.email,
                    relationWithApplicant:
                      values.Relation || localStorage.getItem("Relation"),
                    contactID: resp.ContactId,
                    applyingForSelf: values.applyingForSelf,
                    contactType: resp.contactType,
                    ApplicantAccount: resp.ApplicantAccount,
                    RelationsAccount: resp.RelationsAccount,
                    First_Name: values.firstName,
                    Last_Name: values.lastName,
                  },
                  applicationDetails: {
                    draft: false,
                  },
                  ParentId: resp.ContactId,
                  Email: values.email,
                },
                search: `?name=${currentRow.academicProgram}&instId=${currentRow.instituteId}`,
              });
            } else {
              handleSnackbarOpen(
                "error",
                "Already Registered with same Email or Mobile"
              );
            }
          })
          .catch((error) => {
            //setLoading(false);
            console.log("Error [SignInInfo] Create Contact:", error);
          });
      } else {
        handleSnackbarOpen(
          "error",
          "Invalid Mobile/Phone Number Should Have 10 Numbers"
        );
      }
    },

    displayName: "SignInInformation",
  })(SignInForm);

  return <SignInFormik {...props} />;
};
